"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadingAsyncState = exports.loadedAsyncState = exports.errorAsyncState = exports.unauthorizedAsyncState = exports.unloadedAsyncState = exports.async = exports.httpResult = void 0;
var widgets_main_1 = require("../widgets-main");
var widget_1 = require("../basics/widget");
var options_1 = require("../basics/options");
exports.httpResult = {
    success: function (value) { return ({ kind: "result", value: value, status: 200 }); },
    unauthorized: function () { return ({ kind: "unauthorized", status: 403 }); },
    failed: function () { return ({ kind: "failed", status: 500 }); },
};
var defaultMaxAttempts = 10;
var defaultInterval = 10;
/**
 * An asynchronous wrapper around the w widget.
 * Async is responsible for the dynamics, that is the execution of the
 * asynchronous process emboded by the supplied async state.
 * @param w The widget used to render&manage the loaded value
 * If you don't provide this is same as providing the empty widget `nothing()`
 * @param s0 The inner async state. It usually starts as unloaded.
 * Every time the inner asyncstate is set to loading by the client application, the asynchronous
 * state machine is started and the promise will fire. This means than in case of a promise
 * containing a remote call to an API, the networking communication runs at that point.
 *
 *@param options governing the rendering of temporary asynchronous states, caching, and retrying
 *
 */
var async = function (s0, w, options) {
    return (0, widgets_main_1.any)(s0.kind == "loaded"
        ? w
            ? [w(s0.value)]
            : []
        : s0.kind == "loading"
            ? __spreadArray(__spreadArray([], (options && options.loading
                ? [options.loading(s0).never()]
                : []), true), [
                (0, widgets_main_1.promise)(function (_) {
                    var cacheHit = options &&
                        options.cache &&
                        !options.cache.forceFlush &&
                        s0.cache.kind == "populated" &&
                        (Date.now() - s0.cache.loadedAt.valueOf()) / 1000 <=
                            options.cache.expiryInSeconds;
                    var p = cacheHit && s0.cache.kind == "populated"
                        ? Promise.resolve(exports.httpResult.success(s0.cache.value))
                        : s0.p({});
                    return p.then(function (res) { return function (_) {
                        return res.kind == "result"
                            ? __assign(__assign({}, s0), { kind: "loaded", retryCount: 0, value: res.value, cache: options && options.cache
                                    ? cacheHit
                                        ? s0.cache
                                        : {
                                            kind: "populated",
                                            value: res.value,
                                            loadedAt: Date.now()
                                        }
                                    : { kind: "empty" } }) : res.kind == "unauthorized"
                            ? __assign(__assign({}, s0), { kind: "unauthorized", status: res.status }) : __assign(__assign({}, s0), { kind: "failed", status: res.status });
                    }; });
                }, {
                    on_fail: function (e) { return function (s1) {
                        console.log("The request failed for the following reason:");
                        console.log(e);
                        // NOTE: only connection-error is fed inside here, unless somebody intercepts it
                        return s1.kind == "loading" ||
                            s1.kind == "failed" ||
                            s1.kind == "connection-error" ||
                            s1.kind == "unauthorized"
                            ? s0.retryCount == undefined || s0.retryCount < (options && options.retry && options.retry.maxAttempts || defaultMaxAttempts)
                                ? __assign(__assign({}, s1), { kind: "connection-error", retryCount: s1.retryCount ? s1.retryCount + 1 : 1 }) : __assign(__assign({}, s1), { kind: 'failed', retryCount: 0, status: 500 })
                            : s1;
                    }; },
                    key: "async-promise-".concat((0, options_1.option)("key", options) || "")
                })({})
            ], false) : s0.kind == "connection-error"
            ? __spreadArray(__spreadArray([], (options && options.connectionError != undefined
                ? [options.connectionError.never()]
                : []), true), [
                s0.retryCount == undefined || s0.retryCount < (options && options.retry && options.retry.maxAttempts || defaultMaxAttempts)
                    ? (0, widgets_main_1.wait)(options && options.retry && options.retry.interval || defaultInterval, { key: "async-connection-error-".concat((0, options_1.option)("key", options) || "") })(function () { return function (_) { return (__assign(__assign({}, s0), { kind: "loading" })); }; })
                    : (0, widget_1.nothing)()
            ], false) : s0.kind == "unauthorized"
            ? options && options.unauthorizedError
                ? [options.unauthorizedError]
                : []
            : s0.kind == "failed"
                ? options && options.otherError
                    ? [options.otherError]
                    : []
                : options && options.unloaded
                    ? [options.unloaded]
                    : [], options);
};
exports.async = async;
/**
 * A way to create a (initial) unloaded async state.
 * @param cache to start with
 */
var unloadedAsyncState = function (cache) { return ({
    kind: "unloaded",
    cache: cache ? __assign({}, cache) : { kind: "empty" }
}); };
exports.unloadedAsyncState = unloadedAsyncState;
/**
 *
 * @deprecated Not much used explicitly. Just a helper function.
 */
var unauthorizedAsyncState = function (status) { return ({
    kind: "unauthorized",
    cache: { kind: "empty" },
    status: status,
    p: function () { return new Promise(function (_) { }); }
}); };
exports.unauthorizedAsyncState = unauthorizedAsyncState;
/**
 * @deprecated Not much used explicitly. Just a helper function.
 */
var errorAsyncState = function (status) { return ({
    kind: "failed",
    cache: { kind: "empty" },
    status: status,
    p: function () { return new Promise(function (_) { }); }
}); };
exports.errorAsyncState = errorAsyncState;
/**
 * A way to create an already-resolved async state
 *
 * @param v The resolved value injected
 */
var loadedAsyncState = function (v) { return ({
    kind: "loaded",
    cache: { kind: "populated", value: v, loadedAt: Date.now() },
    value: v
}); };
exports.loadedAsyncState = loadedAsyncState;
/**
 * A way to setup an asynchronous process, around an inputted lazy promise.
 * @param p The promise
 * @param old_value The previously loaded value (if available or relevant, used by the loading? widget)
 * @param cache
 */
var loadingAsyncState = function (p, old_value, cache) { return ({
    kind: "loading",
    value: old_value,
    cache: cache ? __assign({}, cache) : { kind: "empty" },
    p: p
}); };
exports.loadingAsyncState = loadingAsyncState;
